import {
  FilterCriteriaType, FilterValuesType, TariffOfferType,
} from '@/types/av-check';

export function getMatchedTariffOffers(tariffOffers: TariffOfferType[], filterValues: FilterValuesType): TariffOfferType[] {
  let filteredOffers: TariffOfferType[] = tariffOffers;

  filteredOffers = filteredOffers.filter((item) => (
    (!(item.specialReservation || filterValues.SPECIAL_RESERVATION) && (item.targetGroup === filterValues.TARGET_GROUP))
      || (item.specialReservation && filterValues.SPECIAL_RESERVATION)
      || (filterValues.TARGET_GROUP === undefined)));

  filteredOffers = filteredOffers.filter((item) => (
    (item.contractDuration === filterValues.CONTRACT_DURATION) || (filterValues.CONTRACT_DURATION === undefined)));

  return filteredOffers;
}

export function hasMatchedTariff(tariffOffers: TariffOfferType[], filterCriteria: FilterCriteriaType, filterValue: any): boolean {
  switch (filterCriteria) {
    case FilterCriteriaType.CONTRACT_DURATION:
      return tariffOffers.find((tariff) => ((tariff.contractDuration === filterValue))) !== undefined;
    case FilterCriteriaType.TARGET_GROUP:
      return tariffOffers.find((tariff) => (
        !(tariff.specialReservation) && tariff.targetGroup === filterValue)) !== undefined;
    case FilterCriteriaType.SPECIAL_RESERVATION:
      return tariffOffers.find((tariff) => (
        tariff.specialReservation === filterValue)) !== undefined;
    default:
      return false;
  }
}

export const emptyFilterValues = () => ({
  [FilterCriteriaType.TARGET_GROUP]: undefined,
  [FilterCriteriaType.CONTRACT_DURATION]: undefined,
  [FilterCriteriaType.SPECIAL_RESERVATION]: false,
});
